import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Actions */
import { updateUserData, updateUserProfile } from "../../redux/actions/user";
import { setDeleteAccount, setDetailsChanged, setAlert } from "../../redux/actions/misc";

/* Components */
import CoupleRequestButtons from "./components/CoupleRequestButtons";
import TextInputWithIcon from "../../components/TextInputWithIcon";
import CheckBox from "../../components/CheckBox";
import DashboardSectionBase from "../../components/DashboardSectionBase";

/* Helpers */
import { handlePartner } from "../../helpers/couple";

/* API requests */
import { checkEmail } from "../../api-requests/user";
import { sendConnectionRequest, updateConnection } from "../../api-requests/couple";

class SettingsCandidate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            previousEmail: "",
            partnerEmail: "",
        };

    }

    componentDidMount() {

        const { data } = this.props.user;

        return this.setState({ firstName: data.firstName, lastName: data.lastName, email: data.email, previousEmail: data.email })

    }

    handleBasicDetailsChange = ({ firstName, lastName, email, previousEmail }, id) => {

        if (firstName && lastName && email) {

            let body;

            if (previousEmail !== email) {
                body = [{ propName: "firstName", value: firstName }, { propName: "lastName", value: lastName }, { propName: "email", value: email }];
                return checkEmail(email)
                    .then(result => {
                        if (result.status) {
                            return this.setState({ previousEmail: email }, () => {
                                this.props.updateUserData(body, true);
                                this.props.updateUserProfile(body, true);
                                this.props.setDetailsChanged(true);

                                return setTimeout(() => {
                                    return this.props.setDetailsChanged(false);
                                }, 3333);
                            });
                        } else {
                            return this.props.setAlert("This email is already taken. Please try another one.", "error", true);
                        }
                    });
            } else {
                body = [{ propName: "firstName", value: firstName }, { propName: "lastName", value: lastName }];
                
                this.props.updateUserData(body, true);
                this.props.updateUserProfile(body, true);
                this.props.setDetailsChanged(true);

                return setTimeout(() => {
                    return this.props.setDetailsChanged(false);
                }, 3333);
            }
        }
        return this.props.setAlert("All detail fields are required.", "error", true);

    }

    handleAddingPartner = (email, myEmail, id) => {

        if (email === myEmail) return this.props.setAlert("Nice try! :)", "error", true);

        if (email) {
            return checkEmail(email)
                .then(result => {
                    if (!result.status) {
                        return sendConnectionRequest(id, result._id)
                            .then(result => {
                                if (result?.couple) {
                                    this.setState({ partnerEmail: "" });
                                    return this.props.updateUserProfile([{ propName: "couple", value: result.couple }]);
                                }
                                return this.props.setAlert("Something went wrong. Please try again.", "error", true);
                            });
                    } else {
                        return this.props.setAlert("There is no user corresponding to this email.", "error", true);
                    }
                });
        } else {
            return this.props.setAlert("Partner's email is required.", "error", true);
        }

    }

    handleConnectionUpdate = (partner, status) => {

        const { profile } = this.props.user.data;

        return updateConnection(partner.coupleId, status)
            .then(result => {
                if (result.error) return;

                if (status === "cancelled" || status === "declined" || status === "removed") return this.props.updateUserProfile([ { propName: "couple", value: null } ]);

                return this.props.updateUserProfile([ { propName: "couple", value: { ...profile.couple, status: "linked" } } ]);
            });

    }

    handlePartnerText = (partner) => {

        if (!partner) return "To connect your account with your partner, please enter the email address of your partner below.";
        if (partner.status === "linked") return "Your accounts are connected. Apply for positions as a couple.";
        if (partner?.role === "receiver") return "You have requested to partner up with "+partner.name+". An email has been sent out.";
        if (partner?.role === "sender") return "Connecting your accounts will enable you to apply for positions as a couple.";

        return "";

    }

    render() {

        const { data } = this.props.user,
            partner = handlePartner(data.profile.couple, data._id);

        return(
            <div className="c-settings-container">
                <div className="c-settings-title-container">
                    <p>Account Settings</p>
                </div>

                <DashboardSectionBase title="Basic Details" subtitle="Your name and the email address we contact you on.">
                    <div className="margin-top-20px">
                        <TextInputWithIcon value={this.state.firstName} onChangeText={(e) => this.setState({ firstName: e })} placeholder={"First Name"} hide={false} />
                    </div>
                    <div className="margin-top-20px">
                        <TextInputWithIcon value={this.state.lastName} onChangeText={(e) => this.setState({ lastName: e })} placeholder={"Last Name"} hide={false} />
                    </div>
                    <div className="margin-top-20px">
                        <TextInputWithIcon value={this.state.email} onChangeText={(e) => this.setState({ email: e })} onBlur={() => this.setState({ emailTouched: true })} placeholder={"Email"} hide={false} type="email" inputMode="email" autoComplete="email" error={this.state.emailTouched && this.state.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)} />
                        {this.state.emailTouched && this.state.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email) &&
                            <p style={{ marginTop: 6, marginBottom: 0, fontSize: 12, lineHeight: "16px", color: "#F55D5D", fontFamily: "OpenSans-Regular, Arial, Helvetica, sans-serif" }}>That doesn't look like a valid email address.</p>
                        }
                    </div>
                    <div className="margin-top-20px">
                        <div className="change-password-button" onClick={() => this.handleBasicDetailsChange(this.state)}>
                            <p>Update Account Settings</p>
                        </div>
                    </div>
                </DashboardSectionBase>

                <DashboardSectionBase title="Couples Account Connection" subtitle={this.handlePartnerText(partner)}>
                    <div className="margin-top-20px">
                        <TextInputWithIcon value={partner ? partner.name+", "+partner.email : this.state.partnerEmail} onChangeText={(e) => this.setState({ partnerEmail: e })} placeholder={partner ? "Partner" : "Partner's Email Address"} hide={false} disabled={partner ? true : false} />
                    </div>
                    <div className="margin-top-20px" style={{display: "flex", flexDirection: "row"}}>
                        <CoupleRequestButtons partner={partner} handleConnectionUpdate={this.handleConnectionUpdate} handleAddingPartner={() => this.handleAddingPartner(this.state.partnerEmail, data.email, data._id)} />
                    </div>
                </DashboardSectionBase>

                <DashboardSectionBase title="Notifications" subtitle={`Choose which notifications you wish to receive. Sent to ${data.email}.`}>
                    <div className="c-settings-notifications-item-container margin-top-20px">
                        <CheckBox label={"Monthly Newsletter"} propName={"newsLetter"} value={data?.newsLetter ? false : true} status={data?.newsLetter} toggle={this.props.updateUserData} />
                    </div>
                </DashboardSectionBase>

                <DashboardSectionBase title="Help & account">
                    <div className="c-settings-delete-account-container">
                        <p>Have questions? We're only an email away: <a href={"mailto:crew@j4crew.com"} className="c-settings-email">crew@j4crew.com</a></p>
                        <p style={{ marginTop: 8 }}>To delete your account, please <span className="c-settings-delete-account" onClick={() => this.props.setDeleteAccount(true, false)}>click here</span>.</p>
                    </div>
                </DashboardSectionBase>
            </div>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ updateUserData, setDeleteAccount, setDetailsChanged, updateUserProfile, setAlert }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsCandidate);